module.exports = __webpack_public_path__ + "img/my-complaint.d5d250ff.svg";